import { render, staticRenderFns } from "./MyAssets.vue?vue&type=template&id=18bb6586&scoped=true"
import script from "./MyAssets.vue?vue&type=script&lang=js"
export * from "./MyAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb6586",
  null
  
)

export default component.exports